import React, { useEffect } from "react";
import "../styles/Parallax.css";

/* Default assets */
import defaultBg from "../assets/tt23.png";
import callIcon from "../assets/call1.png";

const Parallax = ({
  backgroundImage = defaultBg,
  title = "Call Any Time For Booking",
  subtitle = "Available 24/7",
  phone = "+919486589488"
}) => {


  useEffect(() => {
    document.title =
      "Book Tempo Traveller | 18 Seater AC Traveller in Mayiladuthurai | MahaCabs";

    const setMeta = (name, content) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", name);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    };

    setMeta(
      "description",
      "Call Maha Cabs to book 18-seater AC Tempo Traveller in Mayiladuthurai. Available 24/7 for family trips, hill stations, temple tours, and outstation travel with experienced driver."
    );

    setMeta(
      "keywords",
      "tempo traveller in mayiladuthurai, 18 seater tempo traveller mayiladuthurai, ac tempo traveller hire mayiladuthurai, best tempo traveller service mayiladuthurai, maha cabs booking, luxury tempo traveller mayiladuthurai"
    );
  }, []);
  // ================================================

  /* Hover effect */
  const handleMove = (e) => {
    const btn = e.currentTarget;
    const circle = btn.querySelector(".hover-circle");

    const rect = btn.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    circle.style.left = x + "px";
    circle.style.top = y + "px";
  };

  return (
    <div className="call-banner-full">
      <div
        className="call-banner-wrapper parallax-bg"
        style={{ backgroundImage: `url(${backgroundImage})` }}
        role="img"
        aria-label="18 seater AC Tempo Traveller in Mayiladuthurai"
      >
        <div className="call-banner-left">
          <span className="available">{subtitle}</span>

          <h2>{title}</h2>

          <div className="call-info">
            <div className="call-banner-right">
              <a
                href={`tel:${phone}`}
                className="center-call-btn btn-6"
                onMouseEnter={handleMove}
                onMouseLeave={handleMove}
                aria-label="Call Maha Cabs to book Tempo Traveller"
              >
                <span className="hover-circle"></span>

                <img
                  src={callIcon}
                  alt="Call Maha Cabs for Tempo Traveller Booking in Mayiladuthurai"
                  className="btn-call-icon"
                />

                Call Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Parallax;
